import { render } from "./dreidimensional.vue?vue&type=template&id=713f4d10"
import script from "./dreidimensional.vue?vue&type=script&lang=js"
export * from "./dreidimensional.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__